import React from 'react';
import PropTypes from 'prop-types';
import { Col, Modal, Row } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';

import 'animate.css';

export default function IntroStep({ onFromExistingSelected, onFromScratchSelected }) {
  return (
    <Modal.Body className="py-8" >
      <h5 className="fw-bold text-center my-4">Create a new listing</h5>
      <Row>
        <Col md={{ span: 8, offset: 2 }}>
          {onFromExistingSelected && (
            <div
              className="btn btn-outline d-block py-4 my-4"
              name="from-existing"
              onClick={onFromExistingSelected}
            >
              <div className="text-center text-primary mb-1">
                <FontAwesomeIcon
                  icon={faBuilding}
                  style={{ fontSize: '2.5rem' }}
                />
              </div>
              <p className="text-center mt-2 mb-0">Start from an existing property</p>
            </div>
          )}
          <div
            className="btn btn-outline d-block py-4 my-4"
            name="from-scratch"
            onClick={onFromScratchSelected}
          >
            <div className="text-center text-primary mb-1">
              <FontAwesomeIcon
                icon={faPlus}
                style={{ fontSize: '2rem' }}
              />
            </div>
            <p className="text-center mt-2 mb-0">Start a new listing from scratch</p>
          </div>
        </Col>
      </Row>
    </Modal.Body>
  );
}

IntroStep.propTypes = {
  onFromExistingSelected: PropTypes.func,
  onFromScratchSelected: PropTypes.func.isRequired
};
